/**
 * Cargo business units available in the JSON-forms pre-screen flow.
 *
 * Each entry has:
 * - `label`  — the user-facing string rendered in the Cargo pre-screen
 *   business-unit `Select` dropdown.
 * - `value`  — the stable identifier persisted to
 *   `state.jsonForms.preScreen.cargo.businessUnit` and used as the
 *   Cloudscape option value.
 * - `schemaSegment` — the segment injected into the Cargo schema name
 *   (`Cargo-<schemaSegment>-v1_0_0`) sent to the FinTechCloudscape JSON
 *   Forms Studio service.
 *
 * Adding a new Cargo business unit requires appending a new entry here;
 * no changes are needed in `CargoPreScreen.tsx` (the component reads
 * directly from this array).
 */
export interface CargoBusinessUnit {
  label: string;
  value: string;
  schemaSegment: string;
}

export const CARGO_BUSINESS_UNITS: ReadonlyArray<CargoBusinessUnit> = [
  // Additional business units will be added as schemas are onboarded.
  {
    label: "EU Middle Mile",
    value: "10272671",
    schemaSegment: "WKW_EU_Middle_Mile",
  },
];
